import { activityLogsApi } from '../api/modules/activityLogs.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { getActivityLogs } from '../data/staff/activityLogsStore';
import { activityLogFromApi, mapPaginated } from '../models';

export async function listActivityLogs(params = {}) {
  if (!USE_API) {
    let items = [...getActivityLogs()];
    if (params.staffId) {
      items = items.filter((l) => l.staffId === params.staffId);
    }
    if (params.search) {
      const q = String(params.search).toLowerCase();
      items = items.filter(
        (l) =>
          l.summary?.toLowerCase().includes(q) ||
          l.module?.toLowerCase().includes(q) ||
          l.action?.toLowerCase().includes(q),
      );
    }
    const page = params.page || 1;
    const pageSize = params.pageSize || items.length || 20;
    const start = (page - 1) * pageSize;
    return { items: items.slice(start, start + pageSize), total: items.length, page, pageSize };
  }
  try {
    return mapPaginated(await activityLogsApi.list(params), activityLogFromApi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load activity logs'));
  }
}
